<p class="confirm-modal__message">{{ data.message | translate: data.messageParams }}</p>

<ng-template #footerTpl>
  <p-button type="button" severity="secondary" [label]="data.cancelLabel | translate" (onClick)="cancel()" />
  <p-button
    type="button"
    [severity]="data.confirmSeverity"
    [label]="data.confirmLabel | translate"
    (onClick)="confirm()"
  />
</ng-template>
